
document.addEventListener("DOMContentLoaded", function () {
  const tabs = document.querySelectorAll("ul.shopify-tabs > li");

  tabs.forEach(function (tab) {
    tab.addEventListener("click", function () {
      const tabId = this.getAttribute("data-tab");

      // Remove 'current' class from all tabs and tab content
      this.parentElement.querySelectorAll("li").forEach(function (sibling) {
        sibling.classList.remove("current");
      });
      document.querySelectorAll(".shopify-tab-content").forEach(function (content) {
        content.classList.remove("current");
      });

      // Add 'current' class to the clicked tab and associated content
      this.classList.add("current");
      document.getElementById(tabId).classList.add("current");
    });
  });
});
